import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Zap, AlertCircle } from 'lucide-react';

const Login = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login, signup } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            if (isLogin) {
                await login(email, password);
            } else {
                await signup(email, password, name);
            }
            navigate('/dashboard');
        } catch (err) {
            console.error(err);
            setError(err.message.replace('Firebase: ', ''));
        }

        setLoading(false);
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'var(--color-bg-primary)',
                padding: 'var(--space-4)'
            }}
        >
            <div className="card" style={{ width: '100%', maxWidth: '400px', padding: 'var(--space-8)' }}>
                <div style={{ textAlign: 'center', marginBottom: 'var(--space-8)' }}>
                    <img
                        src="/favicon.png"
                        alt="Vitisiti"
                        style={{
                            width: '60px',
                            height: '60px',
                            margin: '0 auto var(--space-4)',
                            display: 'block'
                        }}
                    />
                    <h1 style={{ fontSize: 'var(--font-size-2xl)', marginBottom: 'var(--space-2)' }}>
                        {isLogin ? 'Welcome Back' : 'Create Account'}
                    </h1>
                    <p className="text-secondary">
                        {isLogin ? 'Sign in to continue to Vitisiti' : 'Get started with AI-powered creatives'}
                    </p>
                </div>

                {error && (
                    <div className="alert alert-error" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                        <AlertCircle size={16} />
                        <span style={{ fontSize: 'var(--font-size-sm)' }}>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    {!isLogin && (
                        <div className="input-group">
                            <label className="input-label">Full Name</label>
                            <input
                                type="text"
                                className="input-field"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required={!isLogin}
                            />
                        </div>
                    )}

                    <div className="input-group">
                        <label className="input-label">Email Address</label>
                        <input
                            type="email"
                            className="input-field"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label className="input-label">Password</label>
                        <input
                            type="password"
                            className="input-field"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            minLength={6}
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ width: '100%', marginBottom: 'var(--space-4)' }}
                        disabled={loading}
                    >
                        {loading ? 'Please wait...' : (isLogin ? 'Sign In' : 'Create Account')}
                    </button>
                </form>

                <div style={{ textAlign: 'center', fontSize: 'var(--font-size-sm)' }}>
                    <span className="text-secondary">
                        {isLogin ? "Don't have an account? " : "Already have an account? "}
                    </span>
                    <button
                        className="btn btn-ghost"
                        style={{ padding: '0 var(--space-1)', height: 'auto', minHeight: 0 }}
                        onClick={() => setIsLogin(!isLogin)}
                    >
                        {isLogin ? 'Sign Up' : 'Sign In'}
                    </button>
                </div>

                <div style={{
                    textAlign: 'center',
                    fontSize: 'var(--font-size-xs)',
                    marginTop: 'var(--space-4)',
                    paddingTop: 'var(--space-4)',
                    borderTop: '1px solid var(--color-border)'
                }}>
                    <span className="text-secondary">
                        By continuing, you agree to our{' '}
                    </span>
                    <Link
                        to="/terms-of-service"
                        style={{
                            color: 'var(--color-primary)',
                            textDecoration: 'none'
                        }}
                    >
                        Terms of Service
                    </Link>
                    <span className="text-secondary"> and </span>
                    <Link
                        to="/privacy-policy"
                        style={{
                            color: 'var(--color-primary)',
                            textDecoration: 'none'
                        }}
                    >
                        Privacy Policy
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Login;
